import React from 'react';
import idcardcss from '../pages/css/idcard.module.css';
import { useState } from 'react';
import { useEffect } from 'react';
import { downloadfile, getfilesurl, deletefile, saveFile, deletedoctype } from "../tools/filehandler";
import { setErrorMessage } from "../tools/errorhandling";
import DatePicker from "react-datepicker";
import { CgCloseR } from "react-icons/cg";
import Button from 'react-bootstrap/Button';
import { setMessage, setLoading, clearLoading } from '../tools/errorhandling';
import {
    createZiektebriefjes, updateZiektebriefje
} from "../dbconnector/connector";

import { MdEdit } from "react-icons/md";
import moment, { now } from "moment";



const AddDoctorsNote = ({ rights, t, user, doctorsnote, events }) => {


    const [idcard, setId] = useState([]);
    const [loaddnewfile, setloaddnewfile] = useState(true);
    const [ziektebriefjeFile, setZiektebriefjeFile] = useState({});
    const [ziektebriefje, setZiektebriefje] = useState({});



    useEffect(() => {
        setZiektebriefjeFile({})
        document.getElementById("uploadziektebriefjes").value = ""
        setZiektebriefje(doctorsnote)
        if (doctorsnote.filelink) {
            setloaddnewfile(false)
        } else { setloaddnewfile(true) }
        if (!doctorsnote.Id) {
            setZiektebriefje((prev) => {
                return {
                    ...prev,
                    ziek_van: moment(Date.now()).format("YYYY-MM-DD"),
                    ziek_tot: moment(Date.now()).format("YYYY-MM-DD")
                }
            })
        }
        if (!user.Id) {
            setZiektebriefje((prev) => {
                return {
                    ...prev,
                    werknemer_id: user.id
                }
            })
        }

    }, [doctorsnote, user]);


    const changevalue = (e) => {
        //  ziek_van: moment(Date.now()).format("YYYY-MM-DD"),
        setZiektebriefje((prev) => {
            return {
                ...prev,
                [e.target.name]: moment(e.target.value).format("YYYY-MM-DD")
            }
        })

    }


    const loadnewfile = async (e) => {
        setloaddnewfile(true)
    }
    const create_newdoctersnote = async () => {
        await setLoading(t("Loadingfiles"))

        const serverresponse = await saveFile(ziektebriefjeFile, 12, user.id)

        console.log(serverresponse)
        let filelink = serverresponse.id;
        let filename = serverresponse.url;
        if (filelink === null) {
            filelink = ziektebriefje.filelink;
            filename = ziektebriefje.filename;
        }

        const newziektebriefje =
        {
            Id: ziektebriefje.Id,
            UploadDate: ziektebriefje.UploadDate,
            ziek_van: ziektebriefje.ziek_van,
            ziek_tot: ziektebriefje.ziek_tot,
            filelink:filelink,
            filename:filename,
            werknemer_id: ziektebriefje.werknemer_id
        }

        if (!ziektebriefje.Id) {
            delete newziektebriefje.Id
            delete newziektebriefje.UploadDate
            await createZiektebriefjes(newziektebriefje).then((res) => {
                if (res.status === 200) {
                    clearLoading()
                    events.LoadDoctorsNotes(user.id)
                    events.handleCancel()
                }
            })
        }
        else {
            await updateZiektebriefje(newziektebriefje).then((res) => {
                if (res.status === 200) {
                    clearLoading()
                    events.LoadDoctorsNotes(user.id)
                    events.handleCancel()
                }
            })
        }


    }
    return (
        <div id="add_doctorsnote" className='doctorsNote'>
            <div className='formcaption'>
                <div onMouseDown={(e) => events.startdrag("add_doctorsnote", true, e)} onMouseUp={(e) => events.startdrag(null, false, e)}>
                    {t(doctorsnote.Id ? 'ChangeDoctorsNote' : 'AddDoctorsNote')}
                </div>
                <div onClick={events.handleCancel} >
                    <CgCloseR className='closer' />
                </div>
            </div>
            <div className="AssignCleaningform">
                {/* <label className='labelhotel' style={{ padding: '12px' }}>
                    {t('Id')}:
                </label>
                <input id="Id" name="Id" className="doublegrid" type='text' disabled="true" value={ziektebriefje.Id} onChange={changevalue}>
                </input> */}
                <label className='labelhotel' style={{ padding: '12px' }}>
                    {t('From')}:
                </label>
                {/* <DatePicker className='doublegrid' placeholderText="dd/MM/YYYY" selected={doctorsnote.ziek_van} showIcon='false' name="ziek_van" dateFormat="dd/MM/YYYY" id="ziek_van"></DatePicker> */}
                <input id="ziek_van" name="ziek_van" className="doublegrid" type='date' value={moment(ziektebriefje.ziek_van).format("YYYY-MM-DD")} onChange={changevalue}>
                </input>
                <label className='labelhotel' style={{ padding: '12px' }}>
                    {t('Till')}:
                </label>
                {/* <DatePicker className='doublegrid' placeholderText="dd/MM/YYYY" selected={doctorsnote.ziek_tot} showIcon='false' name="ziek_tot" dateFormat="dd/MM/YYYY" id="ziek_tot"  /> */}
                <input id="ziek_tot" name="ziek_tot" className="doublegrid" type='date' value={moment(ziektebriefje.ziek_tot).format("YYYY-MM-DD")} onChange={changevalue}>
                    {/* //moment(item.UploadDate).format("DD-MM-YYYY") */}
                </input>
                <label className='labelhotel' style={!loaddnewfile ? { display: 'block', padding: '12px' } : { display: 'none' }}>
                    {t('DoctorsNote')}:
                </label>
                <div className="ziekte_grid" >
                    {/* <DatePicker className='doublegrid' placeholderText="dd/MM/YYYY" selected={doctorsnote.ziek_tot} showIcon='false' name="ziek_tot" dateFormat="dd/MM/YYYY" id="ziek_tot"  /> */}
                    <input id="filename" name="filename" type='text' disabled="true" value={ziektebriefje.filename} style={!loaddnewfile ? { display: 'block', width: '275px' } : { display: 'none' }}>
                    </input>
                    <MdEdit className='icoziekte_grid' style={!loaddnewfile ? { display: 'block' } : { display: 'none' }} onClick={() => loadnewfile()}></MdEdit>

                </div>

                {/* */}
                <label className='labelhotel' style={loaddnewfile ? { display: 'block', padding: '12px' } : { display: 'none' }}>
                    {t('DoctorsNote')}:
                </label>
                <input id="uploadziektebriefjes" type='file' accept='*.*' onChange={(e) => setZiektebriefjeFile(e.target.files[0])} className="doublegrid" style={loaddnewfile ? { display: 'block' } : { display: 'none' }}></input>
                &nbsp;
                <div className='messageBoxes'>
                    <Button type="button" id="CloseMessageButton" className="OkCancel messageBoxAlignRight" onClick={() => create_newdoctersnote()}>{t("OK")}</Button>
                    <Button type="button" id="CancelMessageButton" className="OkCancel messageBoxAlignleft" onClick={() => events.handleCancel()}>{t("Cancel")}</Button>
                </div>
            </div>

        </div>
    );
};


export default AddDoctorsNote;
